import { render, staticRenderFns } from "./ConsistencyRegister.vue?vue&type=template&id=d45df9a8"
import script from "./ConsistencyRegister.vue?vue&type=script&lang=js"
export * from "./ConsistencyRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45df9a8')) {
      api.createRecord('d45df9a8', component.options)
    } else {
      api.reload('d45df9a8', component.options)
    }
    module.hot.accept("./ConsistencyRegister.vue?vue&type=template&id=d45df9a8", function () {
      api.rerender('d45df9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/control_panel/ConsistencyRegister.vue"
export default component.exports